import { render, staticRenderFns } from "./DirectPositionRolesAndResponsibilitiesTreeView.vue?vue&type=template&id=8ec732aa&scoped=true"
import script from "./DirectPositionRolesAndResponsibilitiesTreeView.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectPositionRolesAndResponsibilitiesTreeView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DirectPositionRolesAndResponsibilitiesTreeView.vue?vue&type=style&index=0&id=8ec732aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec732aa",
  null
  
)

export default component.exports